import { makeAutoObservable } from "mobx";
import type { Team } from "@smartsuite/automation-engine-api";

export class TeamsStore {
  list: Team[] = [];
  pageSize: number = 20;

  constructor() {
    makeAutoObservable(this);
  }

  setList(teams: Team[]): void {
    this.list = teams;
  }
}
